define('pwa/model/OfflineDataModel',['require','lib/model/BaseModel','model/CompanyModel','model/CompanyTimeZoneModel','collection/BookingCollection','pwa/plugin/tickets/collection/TicketsCollection','pwa/collection/DashboardSuggestedBookingCollection'],function (require) {

    var Parent = require('lib/model/BaseModel');
    var CompanyModel = require('model/CompanyModel');
    var CompanyTimeZoneModel = require('model/CompanyTimeZoneModel');
    var BookingCollection = require('collection/BookingCollection');
    var TicketsCollection = require('pwa/plugin/tickets/collection/TicketsCollection');
    var DashboardSuggestedBookingCollection = require('pwa/collection/DashboardSuggestedBookingCollection');

    return Parent.extend({

        initialize: function () {

            //TODO for booking, ticket, suggested - should we fetch after client model sync???

            this._companyModel = new CompanyModel();
            this._companyTimeZoneModel = new CompanyTimeZoneModel();
            this._bookingCollection = new BookingCollection();
            this._dashboardSuggestedBookingCollection = new DashboardSuggestedBookingCollection();

            if (Config.getInstance().getPluginStatus('tickets')) {
                this._ticketsCollection = new TicketsCollection();
            }
        },

        preloadMissingData: function () {
            this._companyModel.fetch();
            this._companyTimeZoneModel.fetch();
        },

        preloadClientModelRelatedData: function () {
            this._bookingCollection.fetch({data: {type: 'all'}});
            this._dashboardSuggestedBookingCollection.fetch({data: {limit: 2}});

            if (Config.getInstance().getPluginStatus('tickets')) {
                this._ticketsCollection.fetch({data: {type: 'all'}});
            }
        }

    }, {

        instance: null,

        getInstance: function () {
            if (!this.instance) {
                this.instance = new this();
            }
            return this.instance;
        }

    });

});
